export enum AppointmentStatus {
  NotConfirmed = 0,
  Confirmed,
  NotArrived,
  Arrived
}
